import Container from '@mui/material/Container';

//Sections
import Navbar from '../../sections/Ecommerce/NavBar';
import MainBanner from '../../sections/Ecommerce/MainBanner';
import ProductSection from '../../sections/Ecommerce/ProductSection';
import Banners from '../../sections/Ecommerce/Banners';
import MobileBottomNav from '../../sections/Ecommerce/MobileBottomNav';
import { useEffect } from 'react';
// redux
import { useDispatch } from '../../redux/store';
import { setHistory, setAllProducts } from '../../redux/slices/NuDetect';
import json from '../../data/Products-Ecomerce.json';

export default function HomeScreen() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setHistory('screen', 'Home', 'Home', {}));
    });

    return (
        <>
            <MainBanner />
            <ProductSection />
            <Banners />
            <MobileBottomNav />
        </>
    )
}